export default {
  state: { all: [] },
  mutations: {
    setStatuses(state, statuses) {
      state.all = statuses.statuses
    }
  },
  actions: {},
  getters: {
    getStatusById: state => id => {
      return state.all.find(x => x.id == id)
    }
  }
}
